import React from 'react';
import { withStyles } from '@material-ui/core';
import { getKPIData } from '../utils';

const styles = (theme: any) => ({
  kpiSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 0',
    flexWrap: 'wrap' as const
  },
  kpiCard: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
    minWidth: 100
  },
  kpiValue: {
    fontSize: 22,
    fontWeight: 600,
    color: theme.TextColor,
    lineHeight: 1.2
  },
  kpiLabel: {
    fontSize: 14,
    color: theme.iconColor,
    marginTop: 4,
    lineHeight: 1.2,
  }
});

interface KPISectionProps {
  classes: Record<string, string>;
  rowData: any;
}

const KPISection: React.FC<KPISectionProps> = ({ classes, rowData }) => {
  const kpiData = getKPIData(rowData);

  return (
    <div className={classes.kpiSection}>
      {kpiData.map((kpi) => (
        <div key={kpi.key} className={classes.kpiCard}>
          <span className={classes.kpiValue}>{kpi.value}</span>
          <span className={classes.kpiLabel}>{kpi.label}</span>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(KPISection);
